document.addEventListener("DOMContentLoaded", () => {
  const cards = document.querySelectorAll(".dev-video-player");

  cards.forEach((card) => {
    const video = card.querySelector("video");
    if (!video) return;

    const overlay = card.querySelector(".dev-video-player__overlay"); // may be null — that's OK

    // Mute/unmute elements
    const muteBtn = card.querySelector(".dev-video-player__controls-icon-mute");
    const iconMute = muteBtn?.children[0]; // First child (mute icon)
    const iconUnmute = muteBtn?.children[1]; // Second child (unmute icon)

    // Play/pause elements  
    const playBtn = card.querySelector(".dev-video-player__controls-icon-play");
    const iconPlay = playBtn?.children[0]; // First child (play icon)
    const iconPause = playBtn?.children[1]; // Second child (pause icon)

    // Helpers to show/hide safely
    const show = (el) => {
      if (el) {
        el.style.display = "block";
      }
    };
    const hide = (el) => {
      if (el) {
        el.style.display = "none";
      }
    };

    // Keep icon state in sync with the actual video
    const syncIcons = () => {
      // volume/mute - show what action can be taken
      if (video.muted) {
        // Video is muted, show unmute icon (so user can unmute)
        show(iconUnmute);
        hide(iconMute);
      } else {
        // Video is unmuted, show mute icon (so user can mute)
        show(iconMute);
        hide(iconUnmute);
      }
      // play/pause - show what action can be taken
      if (video.paused) {
        // Video is paused, show play icon (so user can play)
        show(iconPlay);
        hide(iconPause);
        video.classList.add("paused");
      } else {
        // Video is playing, show pause icon (so user can pause)
        show(iconPause);
        hide(iconPlay);
        video.classList.remove("paused");
      }
    };

    // Try to autoplay in the safest way for Safari/iOS
    const expectAutoplay = video.hasAttribute("autoplay");

    const tryAutoplay = () => {
      // Make sure properties are set before calling play()
      video.muted = true; // iOS requires muted for autoplay
      video.playsInline = true; // property, not only attribute
      // Some Safari builds also like this property:
      // video.webkitPlaysInline = true;

      // If already playing, just sync
      if (!video.paused) {
        syncIcons();
        return;
      }

      const p = video.play();
      if (p && typeof p.then === "function") {
        p.then(() => {
          // started
          syncIcons();
        }).catch(() => {
          // Autoplay still blocked — leave Play icon visible
          syncIcons();
        });
      } else {
        // Older browsers (no promise) — just sync on next tick
        setTimeout(syncIcons, 0);
      }
    };

    // Initialize icons pessimistically, then try autoplay shortly after readiness
    syncIcons();

    // When the media can play, attempt autoplay (Safari often waits until this fires)
    if (expectAutoplay) {
      const onCanPlay = () => {
        video.removeEventListener("canplay", onCanPlay);
        tryAutoplay();
      };
      video.addEventListener("canplay", onCanPlay);

      // As a fallback, also try after a short delay (covers cases where canplay is late)
      setTimeout(() => tryAutoplay(), 300);

      // If the element only starts when visible, kick in when intersecting
      if ("IntersectionObserver" in window) {
        const io = new IntersectionObserver(
          (entries) => {
            const e = entries[0];
            if (e && e.isIntersecting) {
              tryAutoplay();
              io.disconnect();
            }
          },
          { threshold: 0.1 }
        );
        io.observe(video);
      }

      // On bfcache restore
      window.addEventListener("pageshow", () => {
        // Safari sometimes pauses on restore; attempt again
        if (video.paused) tryAutoplay();
      });
    }

    // Toggle mute
    muteBtn?.addEventListener("click", () => {
      video.muted = !video.muted;
      syncIcons();
    });

    // Toggle play/pause
    playBtn?.addEventListener("click", () => {
      if (video.paused) {
        video.play().finally(syncIcons);
      } else {
        video.pause();
        syncIcons();
      }
    });

    // Optional: click anywhere on overlay/container to play
    overlay?.addEventListener("click", () => {
      video.play().finally(syncIcons);
    });

    // Keep icons in sync with real media events (authoritative)
    video.addEventListener("volumechange", syncIcons);
    video.addEventListener("play", syncIcons);
    video.addEventListener("pause", syncIcons);
  });
});
